<template>
  <v-container fluid>
    <div>
      <v-row>
        <v-col cols="12">
          <v-tabs v-model="rengiamiTab">
            <v-tabs-slider color="primary"></v-tabs-slider>
            <v-tab
              class="rengiami-tab"
              v-for="item in rengiamiList"
              :key="item.value"
            >
              <h4>{{ item.label }}</h4>
            </v-tab>
          </v-tabs>
        </v-col>
      </v-row>

      <v-tabs-items v-model="rengiamiTab">
        <component
          :is="rengiamiList[rengiamiTab].component"
          class=""
        ></component>
      </v-tabs-items>
    </div>
  </v-container>
</template>

<script>
import TeikejasRengiami from './TeikejasRengiami'
import TeikejasNepRengiami from './TeikejasNepRengiami'

export default {
  name: 'TeikejasRengiamiTab',
  data() {
    return {
      rengiamiTab: 0,
      rengiamiList: [
        {
          label: 'NTR/STSR rengiami dokumentai',
          value: 1,
          component: TeikejasRengiami,
        },
        {
          label: 'NEP rengiami dokumentai',
          value: 2,
          component: TeikejasNepRengiami,
        },
      ],
    }
  },
  computed: {
    isLocal() {
      return process.env.VUE_APP_LOCAL === 'local'
    },
  },
  watch: {
    rengiamiTab(val) {
      //this.showError = false
    },
  },
  created() {
    //
  },
  methods: {
    //
  },
}
</script>
<style lang="scss" scoped>
.dataContainer {
  max-width: 800px;
}
.rengiami-tab {
  min-width: 420px;
}
</style>
